<template>
  <div class="row">
    <div class="col-xl-6"
         id="services">
      <!--begin::Portlet-->
      <div class="m-portlet m-portlet--rounded m-portlet--head-sm">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <h3 class="m-portlet__head-text">
                Login As
              </h3>
            </div>
          </div>
        </div>
        <div class="m-portlet__body">
          <form @submit.prevent="loginAs">
          <div class="row">
            <label class="col-xl-12 col-form-label">
              UserName: <small>(*)</small>
            </label>
            <div class="col-xl-9 col-lg-7 col-md-8 col-sm-8 col-12">

              <input type="text" name="AgentRef"
                 v-model="login"
                 class="form-control m-input m-input--solid"
                 placeholder="AIXAA" required>

              <span class="m-form__help">
                <small>Enter the username to login with</small>
              </span>

            </div>
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-12">
              <button type="submit" class="btn btn-block btn-primary">Login</button>
            </div>
          </div>
          </form>

        </div>

        <!--end::Form-->
      </div>
      <!--end::Portlet-->
    </div>
  </div>
</template>

<script>
  import functions from "@/plugins/functions"
  import {adminauthapi} from '@/interceptors/adminauthapi'
  import { i18n } from "@/plugins/i18n";
  import Cookie from 'js-cookie'

  export default {
    data(){
      return{
        login: '',
      }
    },
    methods: {
      async loginAs(){
        mApp.block("body", {"message": i18n.t('common.LoadingDataPleaseWait')});

        let result = await adminauthapi.post('/internal/loginasclient', {login: this.login})

        if (result.status == 403) {
          swal({
              title: "",
              html: i18n.t('error.server.ErrUserNotAuthorized'),
              type: "error",
              confirmButtonClass: "btn btn-brand m-btn m-btn--wide"
            });
            mApp.unblock("body");
            return
        }

        Cookie.set('access_token', result.data.accessToken, { expires: 3, sameSite: 'Strict' });
        Cookie.set('refresh_token', result.data.refreshToken, { expires: 3, sameSite: 'Strict' });

        //you can now redirect user
        await this.$router.replace(this.$route.query.redirect?this.$route.query.redirect:'/dashboard')

        let user = functions.getUserFromToken(result.data.accessToken)
        toastr.success(this.$t('Dashboard.welcomeMsg', {userName: user.TradeName || user.CompanyName}));

        mApp.unblock("body");
      }
    },
    mounted() {
      if (this.$route.query.login) {
        this.login = this.$route.query.login
        return this.loginAs()
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/dashboard/admin/LoginAs.vue